<template>
  <div>
    <ListSearchToobar v-model="searchRquest" v-bind="searchToobarData" @search='init' ref="topBar" />
    <el-table id="test" :data="tableData" style="width: 100%" @row-dblclick="dblclickAction" :height="tableHeight" v-loading="loading" highlight-current-row v-dynamicLoading="{fn: getListData}" cell-class-name="gray-back" header-row-class-name="highlight-last">
      <el-table-column width="38"></el-table-column>
      <el-table-column type="index" :label="$t('pos')" width="70"></el-table-column>
      <el-table-column prop="firstName" :label="$t('first_name')" width="200" show-overflow-tooltip></el-table-column>
      <el-table-column prop="lastName" :label="$t('last_name')" width="200" show-overflow-tooltip></el-table-column>
      <el-table-column prop="email" :label="$t('email')" show-overflow-tooltip></el-table-column>
      <el-table-column prop="cellphone" :label="$t('cell_phone')" width="180" show-overflow-tooltip></el-table-column>
      <el-table-column prop="type" :formatter="typeFormat" :label="$t('role')" width="120" show-overflow-tooltip></el-table-column>
      <!-- <el-table-column prop="country" label="Dealer Status"></el-table-column> -->
      <el-table-column prop="erpappInstNumber" :label="$t('ERP_qty')" width="100" show-overflow-tooltip></el-table-column>
      <el-table-column prop="active" :label="$t('active')" width="140" :formatter="activeFormat" show-overflow-tooltip></el-table-column>
      <el-table-column prop="operation" :label="$t('operation')" width="110">
        <template slot-scope="scope">
          <el-tooltip :content="$t('disable')" placement="top" effect="light">
            <span class="icon" @click="disableAction(scope)" v-show="scope.row.active === true"><i class="icon-color common-icon icon-no"></i></span>
          </el-tooltip>
          <el-tooltip :content="$t('enable')" placement="top" effect="light">
            <span class="icon" @click="enableAction(scope)" v-show="scope.row.active === false"><i class="icon-color common-icon icon-yes"></i></span>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <Footerbar ref="foot">
      <TotalNum v-bind="totalOptions" ref="totalNum" :totalData="totalNumber" slot="right" />
    </Footerbar>
    <el-dialog :visible.sync="dialogVisible" width="80%" custom-class="dialog-class" :close-on-click-modal="false" destroy-on-close :before-close="handleClose">
      <div slot="title" class="top-title">
        {{ $t('user_information') }}
      </div>
      <formPage ref="formpage" v-if="dialogVisible" @submit="submitOrder" :rowVal="rowVal" :listData="listData" :readModel="readModel" />
      <span slot="footer" class="dialog-footer">
        <!-- <el-button v-show="rowVal.status !== 20" v-if="showBut" type="default" size="mini" round @click="handleModifyClick" style="width: 200px">Modify</el-button>
        <el-button v-show="rowVal.status !== 20" v-if="showBut" type="default" round @click="handleCloseClick" style="width: 200px">Close</el-button>
        <el-button v-show="rowVal.status !== 20" v-if="!showBut" type="primary" size="mini" round @click="handleOkClick" style="width: 200px">Submit</el-button> -->
        <el-button v-show="rowVal.status !== 20" type="default" size="mini" round @click="handleCancelClick" style="width: 200px">{{ $t('cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import ListSearchToobar from '@/components/ListSearchToobar';
import Footerbar from '@/components/Footerbar';
import dynamicLoading from '@/directive/dynamicLoading/index.js';
import userApi from '@/apis/user';
import formPage from './formPage';
import TotalNum from '@/components/TotalNum';
export default {
  name: 'UserList',
  data() {
    return {
      searchToobarData: {
        showBarRight: true,
        floatRight: true,
        formArray: [
          {
            label: this.$t('name'),
            type: 'input',
            model: 'name',
            width: false
          },
          {
            label: this.$t('role'),
            type: 'select',
            model: 'type',
            width: false,
            options: [
              {
                value: '10',
                label: 'User'
              },
              {
                value: '20',
                label: 'Dealer'
              }
            ]
          },
          {
            label: this.$t('email'),
            type: 'input',
            model: 'email',
            width: false
          },
          {
            label: this.$t('cell_phone'),
            type: 'input',
            model: 'phone',
            width: false
          }
        ],
        iconName: 'icon-hr',
        componentName: this.$t('user_list')
      },
      tableData: [],
      listData: [],
      tableHeight: 0,
      totalNumber: 0,
      pageIndex: 1,
      loading: false,
      searchRquest: {
        name: '',
        email: '',
        phone: '',
        type: ''
      },
      totalOptions: {
        flag: false,
        whiteTheme: true,
        type: 'Tenants'
      },
      dialogVisible: false,
      rowVal: {}
    };
  },

  directives: { dynamicLoading },

  mounted() {
    setTimeout(() => {
      const navBarHeight = 80;
      const tabHeight = 10;
      this.tableHeight =
        window.innerHeight -
        navBarHeight -
        tabHeight -
        this.$refs.topBar.$el.offsetHeight -
        this.$refs.foot.$el.offsetHeight + 1;
    }, 100);
    this.init();
  },

  methods: {
    async init() {
      console.log(this.searchRquest);
      this.pageIndex = 1;
      const req = {
        filter: {
          ...this.searchRquest
        }
      };
      const res = await userApi.UserCount(req);
      this.totalNumber = 0;
      this.totalNumber = res.totalNumber;
      this.tableData = [];
      this.getListData();
    },

    async getListData() {
      this.loading = true;
      const req = {
        filter: {
          ...this.searchRquest
        },
        pageIndex: this.pageIndex,
        pageSize: 50
      };
      const res = await userApi.UserList(req);
      console.log(res);
      this.listData = res.list;
      this.tableData.push.apply(this.tableData, res.list);
      this.pageIndex++;
      this.loading = false;
    },

    submitOrder() {
      this.init();
      this.dialogVisible = false;
    },

    handleCancelClick() {
      this.dialogVisible = false;
    },

    dblclickAction(data) {
      this.dialogVisible = true;
      this.readModel = true;
      this.showBut = true;
      this.rowVal = { ...data };
    },

    handleClose(done) {
      if (!this.readModel) {
        // this.$confirm('确认关闭？')
        this.$confirm(this.$t('sure_to_close'))
          .then((_) => {
            done();
          })
          .catch((_) => {});
      } else {
        this.closeDialog();
      }
    },

    closeDialog() {
      this.dialogVisible = false;
    },

    typeFormat(row, column) {
      if (row.type === 10) {
        return 'User';
      } else if (row.type === 20) {
        return 'Dealer';
      }
    },

    activeFormat(row) {
      if (row.active) {
        return 'Enabled';
      } else {
        return 'Disabled';
      }
    },

    async enableAction(data) {
      const req = {
        userId: data.row.id,
        active: true
      };

      const res = await userApi.UserEndisable(req);
      if (res.succeeded) {
        this.$message({
          // message: '启用成功',
          message: this.$t('enabled_success'),
          type: 'success',
          duration: 5000,
          offset: 80
        });
        data.row.active = true;
      }
    },

    async disableAction(data) {
      const req = {
        userId: data.row.id,
        active: false
      };

      const res = await userApi.UserEndisable(req);
      if (res.succeeded) {
        this.$message({
          // message: '禁用成功',
          message: this.$t('disabled_success'),
          type: 'success',
          duration: 5000,
          offset: 80
        });
        data.row.active = false;
      }
    }
  },

  components: {
    ListSearchToobar,
    Footerbar,
    TotalNum,
    formPage
  }
};
</script>

<style lang="scss">
.el-tooltip__popper {
  color: #000 !important;
  max-width: 50%;
  background: #FFF !important;
  border: 1px  solid #000 !important;
  line-height: 1 !important;
  margin-bottom: 0px !important;
}
.el-tooltip__popper .popper__arrow:after {
  border-top-color: #FFF !important;
}
</style>